var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.407,
    height: 78.963,
    viewBox: "0 0 115.407 78.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "playlist_add_check_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "playlist_add_check_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M6,71.172V62.061H52.467v9.111ZM6,46.117V37.006H77.826v9.111ZM6,21.061V11.95H77.826v9.111ZM86.785,90.913,66.133,70.261l6.378-6.53L86.785,77.854l28.093-28.093,6.53,6.53Z",
    transform: "translate(-6 -11.95)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLists);
export default __webpack_public_path__ + "static/media/lists.091caefeccaffa2e4e1d965e3f7dfa69.svg";
export { ForwardRef as ReactComponent };